// Defining the State
const initialState = {
  menuIsOpen: false,
  scrollReady: false,
};

// TYPES
const HANDLE_MENU_STATUS = "HANDLE_MENU_STATUS";
const SCROLL_READY = "SCROLL_READY";

// ACTIONS
export const toggleMenuOpen = (status) => ({
  type: HANDLE_MENU_STATUS,
  payload: status
});
export const scrollReady = (isReady) => ({
  type: SCROLL_READY,
  payload: { scrollReady: isReady },
});

// SELECTORS
export const selectMenuIsOpen = (state) => state.utils.menuIsOpen;
export const selectScrollReady = (state) => state.utils.scrollReady;

// REDUCER
const utilsReducer = (state = initialState, action) => {
  switch (action.type) {
    case HANDLE_MENU_STATUS:
      return {
        ...state,
        menuIsOpen: action.payload
      };
    case SCROLL_READY:
      return {
        ...state,
        scrollReady: action.payload.scrollReady,
      };
    default:
      return state;
  }
};

export default utilsReducer;
